import FleetTracker from "../../views/FleetTracker/Index.vue";
import store from "@/store";
import FEATURES from "@/common/feature-lib";
//import PERMISSIONS from "@/common/permissions-lib";

export default {
	path: "/FleetTracker",
	name: "FleetTracker",
	meta: {
		breadcrumb: "FleetTracker"
	},
	component: FleetTracker,
	props: { pageTransition: "none" },
	beforeEnter: (to, from, next) => {
		if (!store.getters.currentUserHasFeature(FEATURES.FLEET_MANAGEMENT)) {
			next({
				name: "Unauthorized"
			});
		}
		next();
	}
};
